import script from "./DialogCommonFunction.vue?vue&type=script&setup=true&lang=ts"
export * from "./DialogCommonFunction.vue?vue&type=script&setup=true&lang=ts"

import "./DialogCommonFunction.vue?vue&type=style&index=0&id=0194053a&lang=scss"

const __exports__ = script;

export default __exports__